<ng-container *transloco="let t; prefix: 'scDeviceLicense.state-icon'">
	<ng-container
		*ngTemplateOutlet="
			deviceLicense.state === deviceLicenseStateEnum.GracePeriod ? warningTemplateRef : errorTemplateRef;
			context: {
				tooltip: t('tooltip', {
					title: deviceLicense.state | licenseStateTitlePipe
				}),
				onClick
			}
		"
	></ng-container>
</ng-container>
